import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { Box, SidebarModal, Text } from '@campaignhub/suit-theme'
import PageContext from '@contexts/pageContext'

import AssetComment from './components/AssetComment'

const AssetClientModal = (props) => {
  const { callbacks, modalKey, showModal } = props

  const { clientComments: comments } = useContext(PageContext)

  return (
    <SidebarModal
      callbacks={callbacks}
      modalKey={modalKey}
      showModal={showModal}
      size="small"
    >
      <SidebarModal.Header callbacks={callbacks} title="Asset" titleSecondLine="Client" />
      <SidebarModal.Content boxProps={{ padding: 0 }} hasFooter={false}>
        <Box flexDirection="column" alignItems="center" paddingX="large" width="100%">
          {comments?.sort((a, b) => (a.id > b.id ? -1 : 1)).map(comment => (
            <AssetComment key={comment.id} comment={comment} />
          ))}
          {!comments?.length && (
            <Box paddingY="large" justifyContent="center">
              <Text fontSize="xsmall" color="bodyFontLightColor">No comments</Text>
            </Box>
          )}
        </Box>
      </SidebarModal.Content>
    </SidebarModal>
  )
}

AssetClientModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

AssetClientModal.defaultProps = {
  modalKey: 'AssetClientModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <AssetClientModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
